module.exports = __webpack_public_path__ + "img/market.64966b40.svg";